import * as zoid from "/static/zoid.js";

const MAXIMUM_WIDGETS = 5;

for (let i = 0; i < MAXIMUM_WIDGETS; i++) {
  zoid.create({
    tag: `hed-widget-${i}`,
  });
}
